/**
 * <Panel 
 *		// please describe props here
 *	/>
 *
 * - When there is a nesting tr, we use tbody as a row.
 *
 * @parent anybody
 * @children 
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import './Panel.scss';

class Panel extends React.Component {
  static propTypes = {

  }

  static defaultProps = {
    title: PropTypes.string,
    color: PropTypes.string, 
  }

  constructor(props) {
    super(props);
  }

  componentWillMount() {

  }
  
  render() {
    const { title, titleContent } = this.props;

    return (
      <div className='classtop-panel'>
        <section className='title-section'>
          <h5>{title}</h5>
          <div className='title-content'>
            {titleContent}
          </div>
        </section>
        <section className='content-section'>
          {this.props.children}
        </section>
      </div>
    )
  }
}

export default Panel;



// WEBPACK FOOTER //
// ./src/components/UI/Panel/index.js